export const validateForm = (formData, t) => {
    const errors = [];

    const phoneRegex = /^\+9989\d{8}$/;
    if (formData.phone && !phoneRegex.test(formData.phone || '')) {
        errors.push(`${t('translation:wrong_phone_format')} ${t('translation:f-exam')} +998901234567`);
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
        errors.push(t('translation:wrong_email_format'));
    }

    const stirRegex = /^\d{9}$/;
    if (formData.stir && !stirRegex.test(formData.stir || '')) {
        errors.push(t('translation:inn_format'));
    }
    const websiteRegex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(\/[^\s]*)?$/i;
    if (formData.site && !websiteRegex.test(formData.site)) {
        errors.push(t('translation:wrong_web_url'));
    }

    return errors;
};